import companyApiClient from "../../api/companyApiClient";

const companyApiService = {
  login: async (credentials: any) => {
    const response = await companyApiClient.post("/company/login", credentials);
    console.log(response);

    return response.data;
  },
  getCompanies: async () => {
    const response = await companyApiClient.get("/company/companies");
    return response.data;
  },
  getCompaniesWithDetails: async () => {
    const response = await companyApiClient.get(
      "/company/companies-with-details",
    );
    return response.data;
  },
  createCompany: async (companyData: any) => {
    const response = await companyApiClient.post(
      "/company/companies",
      companyData,
    );
    return response.data;
  },
  updateCompany: async (id: string, companyData: any) => {
    const response = await companyApiClient.put(
      `/company/companies/${id}`,
      companyData,
    );
    return response.data;
  },
  deleteCompany: async (id: string) => {
    const response = await companyApiClient.delete(`/company/companies/${id}`);
    return response.data;
  },
  getBranches: async (page: number = 1) => {
    const response = await companyApiClient.get("/company/branches", {
      headers: {
        page: page.toString(),
      },
    });
    return response.data;
  },
  getBranchesForCompany: async (companyId: number) => {
    const response = await companyApiClient.get(
      `/company/companies/${companyId}/branches`,
    );
    return response.data;
  },
  getBranchById: async (id: number) => {
    const response = await companyApiClient.get(`/company/branch/${id}`);
    return response.data;
  },
  getCompanyDetails: async (id: string) => {
    const response = await companyApiClient.get(`/company/companies/${id}`);
    console.log(response);

    return response.data;
  },
  createBranch: async (branchData: any) => {
    const response = await companyApiClient.post("/company/branch", branchData);
    return response.data;
  },
  updateBranch: async (id: string, branchData: any) => {
    const response = await companyApiClient.put(
      `/company/branch/${id}`,
      branchData,
    );
    return response.data;
  },
  deleteBranch: async (id: string) => {
    const response = await companyApiClient.delete(`/company/branch/${id}`);
    return response.data;
  },
  getDashboardStats: async () => {
    const response = await companyApiClient.get("/company/dashboard/stats");
    return response.data;
  },
  getCompanyAnalysis: async (params: {
    startDate: string;
    endDate: string;
    companyId?: number;
  }) => {
    const response = await companyApiClient.get("/company/analysis", {
      params,
    });
    return response.data;
  },

  // ==================== SUBSCRIPTION PLANS ====================
  getPlans: async () => {
    const response = await companyApiClient.get("/company/plans");
    return response.data;
  },
  getActivePlans: async () => {
    const response = await companyApiClient.get("/company/plans/active");
    return response.data;
  },
  createPlan: async (planData: any) => {
    const response = await companyApiClient.post("/company/plans", planData);
    return response.data;
  },
  updatePlan: async (id: string, planData: any) => {
    const response = await companyApiClient.put(
      `/company/plans/${id}`,
      planData,
    );
    return response.data;
  },
  deletePlan: async (id: string) => {
    const response = await companyApiClient.delete(`/company/plans/${id}`);
    return response.data;
  },

  // ==================== SUBSCRIPTIONS ====================
  getAllSubscriptions: async () => {
    const response = await companyApiClient.get("/company/subscriptions");
    return response.data;
  },
  getCompanySubscription: async (companyId: string) => {
    const response = await companyApiClient.get(
      `/company/subscriptions/company/${companyId}`,
    );
    return response.data;
  },
  assignPlanToCompany: async (subscriptionData: any) => {
    const response = await companyApiClient.post(
      "/company/subscriptions/assign",
      subscriptionData,
    );
    return response.data;
  },
  cancelSubscription: async (companyId: string) => {
    const response = await companyApiClient.put(
      `/company/subscriptions/cancel/${companyId}`,
    );
    return response.data;
  },

  // ==================== INVOICES ====================
  getAllInvoices: async () => {
    const response = await companyApiClient.get("/company/invoices");
    return response.data;
  },
  getCompanyInvoices: async (companyId: string) => {
    const response = await companyApiClient.get(
      `/company/invoices/company/${companyId}`,
    );
    return response.data;
  },

  // ==================== PAYMENTS ====================
  getCompanyPayments: async (companyId: string) => {
    const response = await companyApiClient.get(
      `/company/payments/company/${companyId}`,
    );
    return response.data;
  },

  // ==================== PORTAL ADMIN ====================
  createPortalAdmin: async (adminData: any) => {
    const response = await companyApiClient.post(
      "/portal/user/create-portal-admin",
      adminData,
    );
    return response.data;
  },

  createPortalAdminWithCompany: async (adminData: any) => {
    const response = await companyApiClient.post(
      "/portal/user/create-portal-admin-with-company",
      adminData,
    );
    return response.data;
  },
};

export default companyApiService;
